import { render } from "./mainIndex.vue?vue&type=template&id=dccf2f3c&scoped=true"
import script from "./mainIndex.vue?vue&type=script&lang=js"
export * from "./mainIndex.vue?vue&type=script&lang=js"

import "./mainIndex.vue?vue&type=style&index=0&id=dccf2f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccf2f3c"]])

export default __exports__